import { queryDispatchUser } from '@api/announcement';
import ViewMoreSelect from '@components/select/ViewMoreSelect';
import { ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { DataFlagEnum } from '@views/pages/AnnouncementList/announcement';
import { sectorValueMap } from '@views/pages/AnnouncementList/tool';
import { Form, Input } from 'antd';
import { CapsuleTabs } from 'antd-mobile';
import { useEffect, useMemo, useRef } from 'react';
import { useRecoilState } from 'recoil';
import './index.scss';

const { TextArea } = Input;

export const baseSectorTypeNameList = [
  {
    label: 'ALS',
    value: 1,
    key: 'ALS',
    dataFlag: DataFlagEnum.directSelling
  },
  {
    label: 'AMS',
    value: 2,
    key: 'AMS',
    dataFlag: DataFlagEnum.directSelling
  },
  {
    label: 'IND',
    value: 3,
    key: 'IND',
    dataFlag: DataFlagEnum.directSelling
  },
  {
    label: 'ALS_E&R',
    value: 4,
    key: 'ALS_E&R',
    dataFlag: DataFlagEnum.dealer
  },
  {
    label: 'IND&AMS OM',
    value: 5,
    key: 'IND&AMS OM',
    dataFlag: DataFlagEnum.dealer
  },
  {
    label: 'Clinical',
    value: 6,
    key: 'Clinical',
    dataFlag: DataFlagEnum.dealer
  }
];

export const useSalesForm = ({
  open,
  details,
  form,
  noCapsuleTabs,
  type,
  sectorName,
  backUpRequired_N
}: any) => {
  const viewMoreSelectRef = useRef<any>(null);
  const [userInfos] = useRecoilState(userInfo);

  const sectorTypeName = Form.useWatch('sector', form) || '';

  useEffect(() => {
    if (!open || noCapsuleTabs) return;

    const nextSector = details?.sectorTypeValue || 'IND';

    if (form.getFieldValue('sector') !== nextSector) {
      form.setFieldValue('sector', nextSector);
    }
  }, [open, noCapsuleTabs, details?.sectorTypeValue, form]);

  const getListData = async (obj: any) => {
    const currentSector = noCapsuleTabs
      ? sectorName
      : obj.sectorTypeName || form.getFieldValue('sector');

    const params: any = {
      ...obj,
      type: type || 'sales',
      sectorTypeName: currentSector,
      provinceName: details.provinceName,
      cityName: details.cityName,
      dataFlag: details.dataFlag
    };

    params.sectorType = sectorValueMap[params.sectorTypeName];
    const res: any = await queryDispatchUser(params);

    if (obj.needDefault) {
      form.setFieldValue(
        'sales',
        res?.users?.records?.[0]?.userId
          ? `${res?.users?.records?.[0]?.userId}-${res?.users?.records?.[0]?.realName}`
          : undefined
      );
    }

    return {
      data: res?.users?.records || [],
      pageNumber: res?.users?.current,
      total: res?.users?.total
    };
  };

  const handleChangeCapsuleTabs = async (key: string) => {
    form.setFieldsValue({
      ...form.getFieldsValue(),
      sector: key
    });

    // 每次切换tabNeedDefault为true,点击和搜索为false
    const res: any = await querySales(key, true);
    // 每次切换tab自动填充默认销售
    form.setFieldsValue({
      ...form.getFieldsValue(),
      sector: key,
      sales: res?.[0]?.userId
        ? `${res?.[0]?.userId}-${res?.[0]?.realName}`
        : undefined,
      recordRemark: undefined
    });
  };

  const querySales = async (name: string, needDefault: boolean) => {
    const res =
      viewMoreSelectRef?.current &&
      (await viewMoreSelectRef.current.rQuery({
        type: 'sales',
        sectorTypeName: name,
        provinceName: details.provinceName,
        cityName: details.cityName,
        pageNumber: 1,
        pageSize: 10,
        needDefault
      }));

    return res;
  };

  const sectorTypeNameList = useMemo(() => {
    if (userInfos.roleKeys === ROLE_KEYS_MAP.admin) {
      return baseSectorTypeNameList;
    }

    return baseSectorTypeNameList.filter((item) => {
      return item.dataFlag === details.dataFlag;
    });
  }, [details?.dataFlag, userInfos.roleKeys]);

  const salesForm = (
    <div className="pc-footer-sales">
      {!noCapsuleTabs && (
        <>
          <Form.Item
            name="sector"
            hidden
            preserve
            initialValue={sectorTypeName}
          >
            <Input />
          </Form.Item>

          <CapsuleTabs
            className="pc-footer-sales-tabs"
            activeKey={sectorTypeName}
            onChange={handleChangeCapsuleTabs}
          >
            {sectorTypeNameList.map((item) => {
              return <CapsuleTabs.Tab title={item.label} key={item.key} />;
            })}
          </CapsuleTabs>
        </>
      )}

      <Form.Item
        label="选择负责的销售"
        className="pc-footer-sales-select"
        name="sales"
        rules={[{ required: true }]}
      >
        <ViewMoreSelect
          ref={viewMoreSelectRef}
          needInit
          onClick={() => querySales(form.getFieldValue('sector'), false)}
          showSearch
          optionFormat={{
            label: 'realName',
            value: 'userId',
            specialVal: 'realName'
          }}
          onSearch={(value: string) => ({ realName: value })}
          getListData={getListData}
          needDefault
        />
      </Form.Item>

      <Form.Item
        label="备注："
        name="recordRemark"
        rules={[{ required: !backUpRequired_N }]}
      >
        <TextArea placeholder="输入备注内容" rows={3} />
      </Form.Item>
    </div>
  );

  return {
    salesForm
  };
};
